import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Chrome state: the vertical nav (wp/shell §4.18) and where AI mode returns to (docs/ai-mode/wp/AI-1.md). There is no
 * global busy counter (ARCHITECTURE.md §6): loading is per query. Badge counts live in `./counts.ts`.
 */
export const useUiStore = defineStore('ui', () => {
  /** Nav pinned open (xl) or collapsed to icons; not persisted (legacy). */
  const navCollapsed = ref(false)
  /** Nav open as an overlay (below 1200 px); any route change closes it. */
  const navOpen = ref(false)

  function toggleCollapsed(): void {
    navCollapsed.value = !navCollapsed.value
  }

  function setNavOpen(open: boolean): void {
    navOpen.value = open
  }

  /**
   * The page the user left when entering AI mode with the navbar switch (its full path); leaving AI mode goes back
   * there. Per tab and not persisted: after a reload, or when the home rule opened AI mode, leaving goes home.
   */
  const aiReturnTo = ref<string | null>(null)

  function setAiReturnTo(path: string | null): void {
    aiReturnTo.value = path
  }

  return { navCollapsed, navOpen, toggleCollapsed, setNavOpen, aiReturnTo, setAiReturnTo }
})
